import React, { useEffect, useMemo, useState, useRef } from "react";
import { Select, ConfigProvider, Dropdown, Checkbox, Button, Popover, Space, Skeleton, Progress } from "antd";
import "./index.scss"
import { documentUtil, toHsl, parseTime, getPlmUserName } from "@/utils"

export const PopProjectInfo: React.FC<{ loading: boolean, project: API.PROJECT.OverviewProject, info?: API.PROJECT.OverviewProjectData, dashboard?: API.Project.Dashboard }> = (props) => {

    const desc = useMemo(() => {
        if (props.loading) return ""
        let arr = []
        if (props.info?.projectAddress) arr.push(props.info.projectAddress)
        if (props.info?.projectCategory) arr.push(props.info.projectCategory)
        if (props.info?.projectArea) arr.push(props.info.projectArea)
        return arr.join(",")
    }, [props])

    if (props.loading) return (<div className="w-[260px]"> <Skeleton active /></div>)
    return (
        <div className="w-[260px]">
            <div className="text-xs font-bold">{props.project.name}</div>
            <div className="flex items-center text-xs mt-2">
                <div className="w-[80px] text-gray-900 font-bold shrink-0">项目编号</div>
                <div className="text-gray-600">{props.project.code}</div>
            </div>
            <div className="flex text-xs">
                <div className="w-[80px] text-gray-900 font-bold shrink-0">项目概况</div>
                <div className="text-gray-600">{desc}</div>
            </div>
            <div className="flex items-center text-xs font-bold">
                <div className="w-[80px] text-gray-900 shrink-0">下一里程碑</div>
                <div className="text-gray-600">{props.info?.nextMilestone}</div>
            </div>
            <div className="flex text-xs">
                <div className="w-[80px] text-gray-900 font-bold shrink-0">专业负责人</div>
                <div className="text-gray-600 flex flex-wrap gap-1">
                    {props.info?.leaders?.map((v, i) => (
                        <div key={v.id} >
                            <div className="w-[35px] h-[35px] leading-[35px] text-[12px] rounded-full text-white whitespace-nowrap scale-75 text-center overflow-hidden" style={{ background: toHsl(getPlmUserName(v)) }}>{getPlmUserName(v)}</div>
                            <div className="text-center text-xs -mt-1">{v.majorName}</div>
                        </div>
                        
                    ))}
                </div>
            </div>
            <div className="flex items-center text-xs font-bold">
                <div className="w-[80px] text-gray-900">项目进度</div>
                <div className="text-gray-600 flex gap-1">
                    <div>
                        <Progress type="circle" size={40} strokeWidth={16} strokeColor="#475dae" percent={Number(props.dashboard?.projectProgress || 0)} />
                        <div>项目进度</div>
                    </div>
                    <div>
                        <Progress type="circle" size={40} strokeWidth={16} strokeColor="#475dae" percent={Number(props.dashboard?.paymentProgress || 0)} />
                        <div>回款进度</div>
                    </div>
                    <div>
                        <Progress type="circle" size={40} strokeWidth={16} strokeColor="#475dae" percent={Number(props.dashboard?.invoiceProgress || 0)} />
                        <div>开票进度</div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}